module.exports = __webpack_public_path__ + "img/case_pic05.9b790240.png";